import { useState } from "react";
import Link from "next/link";
import { Button } from "@Components/ui";
import { COOKIE_KEYS, STORAGE_KEYS, STORAGE_TYPES } from "@Constants/storage";
import { setActiveCookieConsent } from "@Libs/dynamic-yield/dynamicYield";
import { ICookiesPopUpProps } from "@Types/CookiesPopUp";
import { setItem, getItem } from "@Utils/browserStorage";
import { getCookie, setCookie } from "@Utils/cookies";
import { isCanadianLocale } from "@Utils/locale";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import classes from "./CookiesPopUp.module.scss";

export default function CookiesPopUp({
  mainText,
  privacyText,
  privacyUrl,
  privacyButtonLabel,
  isCookieModelOpen,
}: ICookiesPopUpProps) {
  const [isVisible, setVisible] = useState(true);

  const websiteCookie = getCookie(COOKIE_KEYS.WEBSITE_COOKIE);
  const { languageCode } = useAppSelector(localeSelector);
  const isCanadianUser = isCanadianLocale(languageCode);
  const websiteCookieRejectedForCA =
    typeof window !== "undefined"
      ? getItem(STORAGE_KEYS.COOKIE_REJECTED_CA, STORAGE_TYPES.LOCAL)
      : null;
  const websiteCookieAcceptedForCA =
    typeof window !== "undefined"
      ? getItem(STORAGE_KEYS.COOKIE_ACCEPTED_CA, STORAGE_TYPES.LOCAL)
      : null;

  if (!websiteCookie && websiteCookieAcceptedForCA === "true") {
    setCookie(COOKIE_KEYS.WEBSITE_COOKIE, true, {
      secure: true,
      expires: 365,
    });
  }

  if (
    websiteCookie ||
    websiteCookieAcceptedForCA === "true" ||
    websiteCookieRejectedForCA === "true" ||
    !isVisible
  ) {
    isCookieModelOpen && isCookieModelOpen(false);
    return null;
  } else {
    isCookieModelOpen && isCookieModelOpen(isVisible);
  }

  // TODO: replace with actual cookie
  const handleOnAcceptClick = () => {
    if (isCanadianUser) {
      //Set cookie consent for DY
      setActiveCookieConsent(true);
      setItem(STORAGE_KEYS.DY_COOKIE_CONSENT, "true", STORAGE_TYPES.LOCAL);
      //Set cookie consent for DY ends

      setCookie(COOKIE_KEYS.WEBSITE_COOKIE, true, {
        secure: true,
        expires: 365,
      });
      setItem(STORAGE_KEYS.COOKIE_ACCEPTED_CA, "true", STORAGE_TYPES.LOCAL);
    } else {
      setCookie(COOKIE_KEYS.WEBSITE_COOKIE, true);
    }
    setVisible(false);
    isCookieModelOpen(isVisible);
  };

  const handleOnRejectClickForCA = () => {
    //Set cookie consent for DY
    setActiveCookieConsent(false);
    setItem(STORAGE_KEYS.DY_COOKIE_CONSENT, "false", STORAGE_TYPES.LOCAL);
    //Set cookie consent for DY ends

    setVisible(false);
    setItem(STORAGE_KEYS.COOKIE_REJECTED_CA, "true", STORAGE_TYPES.LOCAL);
    isCookieModelOpen(isVisible);
  };

  return (
    <div className={classes["ccpa"]}>
      <div className={classes["ccpa__container"]}>
        <p className={classes["ccpa__body"]}>
          {mainText}{" "}
          <Link href={privacyUrl ? privacyUrl : ""}>
            <a>{privacyText}</a>
          </Link>
        </p>
        <Button // TODO: add onClick functionallity to set the cookie
          onClick={handleOnAcceptClick}
          type="button"
          className="action action--primary"
        >
          {privacyButtonLabel}
        </Button>
        {isCanadianUser && (
          <div className={classes["ccpa__close-btn-container"]}>
            <a
              onClick={handleOnRejectClickForCA}
              className={classes["ccpa__close-btn"]}
            />
          </div>
        )}
      </div>
    </div>
  );
}
